import { interpolate, type Labels } from "./labels";
import type { InventoryView } from "./sheet_view";

// A section's fold, remembered per device by record and section.
export function foldOf(view: Pick<InventoryView, "record_type" | "id">, section: string, title: string, labels: Labels) {
	return {
		key: `${view.record_type}:${view.id}:${section}`,
		open: interpolate(labels.boxes.unfold, { title }),
		close: interpolate(labels.boxes.fold, { title }),
	};
}
